import { Component } from '@angular/core';

@Component({
  selector: 'placeme-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
})
export class ChipsComponent {}
